import * as React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { Translate } from '../../../../../shared/LanguageService';
import StoreyFileUploadModal from '../StoreyFileUploadModal';

interface IProps {
    title: string;
    reference: string;
    thumbnailReference: string;
    onClick: () => void;
    onAnnotate: () => void;
    onShowUploadModal: () => void;
    showUploadModal: boolean;
    onUpload: () => void;
    dropzoneId: string;
    uploadActionUrl: string;
    upload: boolean;
    onUploadCompleted: () => void;
    onFileUploadCompleted: (response: any) => void;
    onUploadModalClose: () => void;
    isAnnotation: boolean;
    uploadModalTitleSubject: string;
}

const StoreyFile = (props: IProps) => {
    const { apiUrl } = window.appConfig;

    return (
        <fieldset>
            <legend>{props.title} xxx</legend>

            <div className="button-bar-below">
                <div className="content-row">
                    <img
                        onClick={props.onClick}
                        src={`${apiUrl}/file/${props.thumbnailReference}`}
                    />
                    {props.isAnnotation && (
                        <i
                            className="material-icons image-action-warning"
                            title={Translate('order/plan/returned/annotation-title')}
                        >
                            feedback
                        </i>
                    )}
                </div>
                <div className="button-row">
                    <ButtonGroup bsSize="sm">
                        <Button onClick={props.onAnnotate} bsStyle="success">
                            {Translate('order/plan/delivery/annotate')}
                        </Button>
                    </ButtonGroup>
                </div>
            </div>

            {props.showUploadModal && (
                <StoreyFileUploadModal
                    title={
                        Translate('order/plan/delivery/upload-annotation-file-modal/title') +
                        ' ' +
                        props.uploadModalTitleSubject
                    }
                    dropzoneId={props.dropzoneId}
                    actionUrl={props.uploadActionUrl}
                    upload={props.upload}
                    onUploadCompleted={props.onUploadCompleted}
                    onFileUploadCompleted={props.onFileUploadCompleted}
                    onUpload={props.onUpload}
                    closeModal={props.onUploadModalClose}
                />
            )}
        </fieldset>
    );
};

export default StoreyFile;
